// Sawyer 04 manager-beds (B3)
/**
 * Sawyer B3 — a bed write the server refused for the caller's ROLE. The admin
 * app auto-deploys on merge while the server waits for a manual deploy, so a
 * manager can see "Add a bed" before the server accepts it; the generic
 * "You don't have access to this view." would be wrong (it is not a view).
 * Worded to stay true after the deploy too (a role changed mid-session).
 */
export const BED_WRITE_FORBIDDEN_MESSAGE =
  "The server didn't accept that change for your role. Ask a business owner, or try again later — beds for managers may still be rolling out.";

/** The sentence for a failed bed write: the role refusal above, else the server's own sentence, else the fallback. */
export function bedWriteErrorMessage(res: { error?: string; code?: string }, fallback: string): string {
  if (res.code === 'forbidden') return BED_WRITE_FORBIDDEN_MESSAGE;
  return res.error ?? fallback;
}
